import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  headerSummary: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 10,

    [Theme.breakpoints.up('sm')]: {
      paddingBottom: 20,
    },

    '& h6': {
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.primary.main,
      fontSize: Theme.typography.size[3],
      display: 'none',

      [Theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },

    '& svg': {
      paddingLeft: '5px',
    },

    '& .confirmation': {
      '& span': {
        display: 'block',
        [Theme.breakpoints.up('xl')]: {
          fontSize: Theme.typography.size[3],
        },
        [Theme.breakpoints.up('xl')]: {
          fontSize: Theme.typography.size[3],
        },
      },
    },

    '& span': {
      color: Theme.palette.primary.main,
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[2],
      textTransform: 'uppercase',
    },

    '& .flight > div:first-child ': {
      border: '1px solid red',
    },

    '& .flight': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'baseline',

      '& div': {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
      },

      '& .routes:first-of-type': {
        width: '100%',
      },

      '& .routes.one-line': {
        width: 'auto',
      },

      '& svg': {
        padding: '0 5px',
        transform: 'scale(0.9)',

        [Theme.breakpoints.up('sm')]: {
          transform: 'scale(0.7)',
        },
      },

      [Theme.breakpoints.up('sm')]: {
        flex: 1,
        alignItems: 'baseline',

        '& span': {
          color: Theme.palette.gray[750],
          fontFamily: Theme.typography.base.regular,
          fontSize: Theme.typography.size[2],
          [Theme.breakpoints.up('xl')]: {
            fontSize: Theme.typography.size[3],
          },
        },

        '& h6': {
          order: 0,
        },
        '& p': {
          display: 'block',
          order: 1,
          width: '100%',
          color: Theme.palette.gray[750],
          fontFamily: Theme.typography.base.regular,
          [Theme.breakpoints.up('lg')]: {
            width: 'auto',
          },
          [Theme.breakpoints.up('xl')]: {
            fontSize: Theme.typography.size[3],
          },
        },
      },
      [Theme.breakpoints.up('md')]: {
        flexWrap: 'wrap',
        gap: '0 10px',
        flexDirection: 'row',
        alignSelf: 'self-start',
        '& h6': {
          width: '100%',
        },

        '& div': {
          width: 'auto',
        },
      },
      '& .flightsView': {
        display: 'flex',
        flexDirection: 'column',
        [Theme.breakpoints.up('md')]: {
          flexDirection: 'row',
        },

        '& .dividerClasses': {
          display: 'none',
          [Theme.breakpoints.up('md')]: {
            display: 'flex',
            '&:nth-of-type(-1)': {
              display: 'none !important',
            },
          },
        },
        '& .dividerSlash': {
          display: 'none !important',
        },
        '& .hideDivider': {
          display: 'none !important',
        },
      },
    },
    '& .multiCityCase': {
      [Theme.breakpoints.up('md')]: {
        flex: '1 !important',
        alignSelf: 'unset !important',
      },
      [Theme.breakpoints.up('lg')]: {
        flex: '1.2 !important',
        alignContent: 'flex-start',
        '& p': {
          width: 'unset !important',
        },
      },
    },
    [Theme.breakpoints.only('md')]: {
      '& .noMultiCity': {
        flex: '0.9 !important',
      },
    },
    '& .dates': {
      '& p': {
        textAlign: 'right',
        maxWidth: '118px',
        color: Theme.palette.gray[750],
        fontFamily: Theme.typography.base.regular,
        [Theme.breakpoints.up('xl')]: {
          fontSize: Theme.typography.size[3],
        },
      },
      [Theme.breakpoints.up('sm')]: {
        flex: 0.6,
        '& p': {
          textAlign: 'left',
        },
      },
      [Theme.breakpoints.up('lg')]: {
        flex: 1,
        '& p': {
          maxWidth: 'unset',
        },
        '& .datesMultiCityWidth': {
          flex: 0.9,
        },
      },
    },
  },
}));

export default useStyles;
